import React from 'react';
import ReactDOM from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';
import App from '@/App';
import '@/index.css';
import { installChunkRecovery } from '@/lib/chunkRecovery';

// Reload once when a lazy chunk from an older build is gone (#618).
installChunkRecovery();

ReactDOM.createRoot(document.getElementById('root')).render(
  <HelmetProvider>
    <App />
  </HelmetProvider>
);
